import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { password as passwordService } from "../services/api"; // 记得改路径
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Alert,
} from "@mui/material";

export default function ResetPassword() {
    const { token } = useParams<{ token: string }>();
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");

        if (password.length < 6) {
            return setError("Password must be at least 6 characters long");
        }
        if (password !== confirm) {
            return setError("Passwords do not match");
        }

        try {
            setLoading(true);
            const resp = await passwordService.resetPassword(token as string, password);
            if(resp.status !== 200) {
                setError("Failed to reset password");
                return;
            }
            setSuccess(resp.data.message || "Password reset successfully");
            setTimeout(() => navigate("/login"), 2000);
        } catch (err: any) {
            setError(err?.response?.data?.message || "Server error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <img
                    src="/duitleh.png"
                    alt="Duitleh Logo"
                    style={{ width: 130, height: "auto", marginBottom: 16 }}
                />
                <Typography component="h1" variant="h5" fontWeight={"bold"}>
                    Reset Password
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ mt: 2, width: "100%", borderRadius: "13px" }}>
                        {error}
                    </Alert>
                )}

                {success && (
                    <Box width={"100%"}>
                        <Alert severity="success" sx={{ mt: 2, width: "100%", borderRadius: "13px" }}>
                            {success}
                        </Alert>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2,
                                borderRadius: "13px",
                                paddingY: 1.2,
                                textTransform: 'none'
                            }}
                            onClick={() => navigate('/login')}
                        >
                            Login
                        </Button>
                    </Box>
                )}

                {!success && (
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: "100%" }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="New Password"
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            variant="outlined"
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "13px",
                                },
                            }}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="confirm"
                            label="Confirm Password"
                            type="password"
                            id="confirm"
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            variant="outlined"
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "13px",
                                },
                            }}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2,
                                borderRadius: "13px",
                                paddingY: 1.2,
                                textTransform: 'none',
                            }}
                            loading={loading}
                        >
                            Set New Password
                        </Button>
                        <Button
                            fullWidth
                            variant="text"
                            sx={{ textTransform: 'none' }}
                            onClick={() => navigate('/login')}
                        >
                            Sign In
                        </Button>
                    </Box>
                )}
            </Box>
        </Container>
    );
}
